document.addEventListener("DOMContentLoaded", function () {
  const rsLearning = document.querySelector(".rs-learning");
  if (!rsLearning) return;

  const allCategories = rsLearning.querySelectorAll(".rs-main-category");
  const subButtons = rsLearning.querySelectorAll(".sub-category-btn");
  const contentGrids = rsLearning.querySelectorAll(
    ".content-grid, .video-grid, .blog-grid"
  );

  const searchGrid = document.querySelector(".search-results-grid");
  const searchList = searchGrid?.querySelector(".search-list");
  const noResultsMsg = searchGrid?.querySelector(".rs-no-results-message");
  const searchPagination = searchGrid?.querySelector(".pagination");

  const searchInputs = document.querySelectorAll(
    "#rs-search-input, #rs-search-input-mobile, #rs-search-input-desktop"
  );
  const searchInputDesktop = document.getElementById("rs-search-input");

  const menuToggleLabel = document.querySelector(
    ".rs-menu-toggle .rs-selected-subcat"
  );
  const mobileToggle = document.querySelector(".rs-menu-toggle");
  const mobileClearIcon = document.querySelector(".rs-menu-toggle .clear-icon");
  const firstButton = rsLearning.querySelector(".sub-category-btn");
  const searchTitle = searchGrid?.querySelector(".search-title");

  document.querySelectorAll(".product-item").forEach((productItem) => {
    const allDetails = productItem.querySelectorAll(
      "details-disclosure > details"
    );
    if (!allDetails.length) return;

    allDetails.forEach((details) => {
      details.addEventListener("toggle", (event) => {
        if (details.hasAttribute("open")) {
          allDetails.forEach((otherDetails) => {
            if (otherDetails !== details) {
              otherDetails.removeAttribute("open");
            }
          });
        }
      });
    });
  });

  function scrollToLearningTop() {
    const yOffset = -200;
    const y =
      rsLearning.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  function hideAllGrids() {
    contentGrids.forEach((grid) => (grid.style.display = "none"));
    if (searchGrid) searchGrid.style.display = "none";
  }

  function resetToDefault() {
    searchInputs.forEach((inp) => (inp.value = ""));
    if (searchGrid) {
      searchGrid.style.display = "none";
      if (searchPagination) searchPagination.style.display = "none";
      if (noResultsMsg) noResultsMsg.style.display = "none";
      if (searchList) searchList.innerHTML = "";
    }
    mobileToggle?.classList.remove("is-search");
    if (searchTitle) searchTitle.innerHTML = `Search Results`;

    // Ensure main categories are closed on reset
    allCategories.forEach((cat) => cat.classList.remove("open"));

    if (firstButton) {
      firstButton.click();
    }
  }

  allCategories.forEach((categoryEl) => {
    const header = categoryEl.querySelector(".rs-cat-header");
    if (!header) return;
    header.addEventListener("click", () => {
      const willOpen = !categoryEl.classList.contains("open");
      allCategories.forEach((cat) => cat.classList.remove("open"));
      if (willOpen) categoryEl.classList.add("open");
    });
  });

  function showContentGrid(category, tab) {
    hideAllGrids();

    let newActiveGrid;
    if (category) {
      newActiveGrid = rsLearning.querySelector(
        `.content-grid[data-category="${category}"][data-tab="${tab}"]`
      );
    } else {
      newActiveGrid = rsLearning.querySelector(
        `.content-grid[data-tab="${tab}"], .video-grid[data-tab="${tab}"], .blog-grid[data-tab="${tab}"]`
      );
    }

    if (newActiveGrid) {
      newActiveGrid.style.display = "block";
      const allBtn = newActiveGrid.querySelector(
        '.filter-btn[data-filter="all"]'
      );
      if (allBtn) allBtn.click();
    }
  }

  subButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const { category, tab } = this.dataset;
      subButtons.forEach((b) => b.classList.remove("active"));
      this.classList.add("active");

      // Accordion Open/Close Logic
      allCategories.forEach((cat) => cat.classList.remove("open"));

      const parentCategory = this.closest(".rs-main-category");
      if (parentCategory && window.innerWidth >= 750) {
        parentCategory.classList.add("open");
      }

      showContentGrid(category, tab);

      if (menuToggleLabel)
        menuToggleLabel.textContent = this.textContent.trim();
      mobileToggle?.classList.remove("is-search");

      if (searchInputDesktop) searchInputDesktop.value = "";

      scrollToLearningTop();
    });
  });

  if (firstButton) {
    firstButton.click();
  }

  contentGrids.forEach((grid) => {
    const filterButtons = grid.querySelectorAll(".filter-btn");
    const items = grid.querySelectorAll(
      ".product-item, .article-item, .video-item"
    );
    const pagination = grid.querySelector(".pagination");
    const noResults = grid.querySelector(".rs-no-results-message");

    if (!filterButtons.length || !items.length || !pagination) return;

    let itemsPerPage = 6;
    let currentPage = 1;
    let activeFilter = "all";

    function getFilteredItems() {
      return Array.from(items).filter((item) => {
        let showItem = false;

        if (item.classList.contains("product-item")) {
          showItem =
            activeFilter === "all" || item.dataset[activeFilter] === "true";
        } else if (item.classList.contains("article-item")) {
          const itemTags = item.dataset.filter || "";
          showItem =
            activeFilter === "all" ||
            itemTags.split(" ").includes(activeFilter);
        } else if (item.classList.contains("video-item")) {
          const itemCat = item.dataset.filter || "";
          showItem =
            activeFilter === "all" || itemCat.split(" ").includes(activeFilter);
        }

        return showItem;
      });
    }

    function renderPagination(totalPages, page) {
      pagination.innerHTML = "";
      if (totalPages <= 1) return;

      if (page > 1) {
        const prevBtn = document.createElement("button");
        prevBtn.textContent = "Prev";
        prevBtn.className = "page-btn prev-btn";
        prevBtn.addEventListener("click", () => {
          if (currentPage > 1) {
            currentPage--;
            showPage(currentPage);
            scrollToLearningTop();
          }
        });
        pagination.appendChild(prevBtn);
      }

      for (let i = 1; i <= totalPages; i++) {
        const btn = document.createElement("button");
        btn.textContent = i;
        btn.className = "page-btn" + (i === page ? " active" : "");
        btn.addEventListener("click", () => {
          currentPage = i;
          showPage(currentPage);
          scrollToLearningTop();
        });
        pagination.appendChild(btn);
      }

      if (page < totalPages) {
        const nextBtn = document.createElement("button");
        nextBtn.textContent = "Next";
        nextBtn.className = "page-btn next-btn";
        nextBtn.addEventListener("click", () => {
          const totalPagesNow = Math.ceil(
            getFilteredItems().length / itemsPerPage
          );
          if (currentPage < totalPagesNow) {
            currentPage++;
            showPage(currentPage);
            scrollToLearningTop();
          }
        });
        pagination.appendChild(nextBtn);
      }
    }

    function showPage(page) {
      const filteredItems = getFilteredItems();
      const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

      items.forEach((item) => (item.style.display = "none"));

      const start = (page - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      const itemsToShow = filteredItems.slice(start, end);

      itemsToShow.forEach((item) => {
        item.style.display = "";

        if (item.classList.contains("product-item")) {
          const allDisclosures = item.querySelectorAll("details-disclosure");
          const allDetails = item.querySelectorAll(
            "details-disclosure > details"
          );

          // All inner accordions are closed by default before determining which to open
          allDetails.forEach((details) => details.removeAttribute("open"));

          let firstVisibleDetails = null;
          let specificDetailsToOpen = null;

          allDisclosures.forEach((disclosure) => {
            const contentInside = disclosure.querySelector("[data-link-type]");
            const parentElement = disclosure.parentElement;

            const parentHasLinkType =
              parentElement &&
              parentElement.dataset.linkType &&
              parentElement.matches("[data-link-type]");

            let linkType = null;
            let container = disclosure;

            if (contentInside) {
              linkType = contentInside.dataset.linkType;
            } else if (parentHasLinkType) {
              linkType = parentElement.dataset.linkType;
              container = parentElement;
            }

            let isVisible = false;

            if (activeFilter === "all") {
              isVisible = true;
            } else if (linkType === activeFilter) {
              isVisible = true;
            }

            container.style.display = isVisible ? "" : "none";

            if (isVisible && !firstVisibleDetails) {
              firstVisibleDetails = disclosure.querySelector("details");
            }

            if (linkType === activeFilter) {
              specificDetailsToOpen = disclosure.querySelector("details");
            }
          });

          // Only open specific inner accordion when activeFilter is NOT "all"
          if (activeFilter !== "all" && specificDetailsToOpen) {
            specificDetailsToOpen.setAttribute("open", "");
          }
        }
      });

      renderPagination(totalPages, page);

      if (noResults) {
        // **BUG FIX HERE:** Hide grid pagination if no results
        if (filteredItems.length === 0) {
            noResults.style.display = "block";
            pagination.style.display = "none"; 
        } else {
            noResults.style.display = "none";
            pagination.style.display = "";
        }
      }
    }

    filterButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        filterButtons.forEach((b) => b.classList.remove("active"));
        this.classList.add("active");
        activeFilter = this.dataset.filter;
        currentPage = 1;
        showPage(currentPage);
        scrollToLearningTop();
      });
    });

    showPage(currentPage);
  });

  function performSearch(query) {
    if (!searchGrid || !searchList || !searchPagination) return;

    const filter = (query || "").toLowerCase().trim();

    if (filter === "") {
      resetToDefault();
      return;
    }

    if (searchTitle) {
      searchTitle.innerHTML = `Search Results for "<span class="search-query-highlight">${filter}</span>"`;
    }

    contentGrids.forEach((grid) => (grid.style.display = "none"));
    searchGrid.style.display = "block";
    searchList.innerHTML = "";
    mobileToggle?.classList.add("is-search");
    if (menuToggleLabel) menuToggleLabel.textContent = `Search: ${filter}`;

    // Close all main categories when searching
    allCategories.forEach((cat) => cat.classList.remove("open"));

    const products = document.querySelectorAll(".product-item");
    const articles = document.querySelectorAll(".article-item");
    const videos = document.querySelectorAll(".video-item");

    let matches = [];
    const perPage = 12;
    let currentPage = 1;

    function collectMatches(items) {
      items.forEach((item) => {
        const text = item.textContent.toLowerCase();
        if (text.includes(filter)) {
          matches.push(item.cloneNode(true));
        }
      });
    }

    collectMatches(products);
    collectMatches(articles);
    collectMatches(videos);

    function renderPagination(totalPages, page) {
      searchPagination.innerHTML = "";
      if (totalPages <= 1) {
        searchPagination.style.display = "none";
        return;
      }
      searchPagination.style.display = "block";

      if (page > 1) {
        const prevBtn = document.createElement("button");
        prevBtn.textContent = "Prev";
        prevBtn.className = "page-btn prev-btn";
        prevBtn.addEventListener("click", () => {
          if (currentPage > 1) {
            currentPage--;
            renderPage(currentPage);
            scrollToLearningTop();
          }
        });
        searchPagination.appendChild(prevBtn);
      }

      for (let i = 1; i <= totalPages; i++) {
        const btn = document.createElement("button");
        btn.textContent = i;
        btn.className = "page-btn" + (i === page ? " active" : "");
        btn.addEventListener("click", () => {
          currentPage = i;
          renderPage(currentPage);
          scrollToLearningTop();
        });
        searchPagination.appendChild(btn);
      }

      if (page < totalPages) {
        const nextBtn = document.createElement("button");
        nextBtn.textContent = "Next";
        nextBtn.className = "page-btn next-btn";
        nextBtn.addEventListener("click", () => {
          const totalPagesNow = Math.ceil(matches.length / perPage);
          if (currentPage < totalPagesNow) {
            currentPage++;
            renderPage(currentPage);
            scrollToLearningTop();
          }
        });
        searchPagination.appendChild(nextBtn);
      }
    }

    function renderPage(page) {
      searchList.innerHTML = "";
      const start = (page - 1) * perPage;
      const end = start + perPage;
      matches.slice(start, end).forEach((item) => {
        // Ensure inner accordions are closed in search results
        if (item.classList.contains("product-item")) {
          item.querySelectorAll("details-disclosure > details").forEach(details => {
              details.removeAttribute("open");
          });
        }
        searchList.appendChild(item);
      });
      renderPagination(Math.ceil(matches.length / perPage), page);
    }

    if (matches.length > 0) {
      noResultsMsg.style.display = "none";
      currentPage = 1;
      renderPage(currentPage);
    } else {
      // **FIX APPLIED HERE:** Hide pagination when no results are found in the search.
      noResultsMsg.style.display = "block";
      searchPagination.style.display = "none"; 
    }
  }

  if (searchInputs.length) {
    searchInputs.forEach((inp) => {
      inp.addEventListener("keyup", function () {
        performSearch(this.value);
      });
    });
  }

  if (mobileClearIcon) {
    mobileClearIcon.addEventListener("click", (e) => {
      e.stopPropagation();
      resetToDefault();
    });
  }

  const popup = document.querySelector(".rs-menu-popup");
  if (mobileToggle && popup) {
    const popupContent = popup.querySelector(".rs-menu-popup-content");
    const closeBtn = popup.querySelector(".rs-menu-close");
    const okBtn = popup.querySelector(".rs-menu-ok");
    const desktopMenu = rsLearning.querySelector(".rs-menu .rs-menu-list");

    mobileToggle.addEventListener("click", () => {
      if (mobileToggle.classList.contains("is-search")) return;

      if (!desktopMenu) return;
      popupContent.innerHTML = "";
      const clonedMenu = desktopMenu.cloneNode(true);
      popupContent.appendChild(clonedMenu);

      const activeDesktopButton = rsLearning.querySelector(
        ".rs-menu .sub-category-btn.active"
      );

      // Reset mobile menu accordion state to closed
      clonedMenu.querySelectorAll(".rs-main-category").forEach(c => c.classList.remove("open"));

      if (activeDesktopButton) {
        const { category: activeCat, tab: activeTab } =
          activeDesktopButton.dataset;
        const buttonToActivate = activeCat
          ? clonedMenu.querySelector(
              `.sub-category-btn[data-category="${activeCat}"][data-tab="${activeTab}"]`
            )
          : clonedMenu.querySelector(
              `.sub-category-btn[data-tab="${activeTab}"]:not([data-category])`
            );
        if (buttonToActivate) {
          buttonToActivate.classList.add("active");
        }
      }

      clonedMenu.querySelectorAll(".rs-cat-header").forEach((header) => {
        header.addEventListener("click", (e) => {
          e.stopPropagation();
          const parentCat = header.parentElement;
          clonedMenu.querySelectorAll(".rs-main-category").forEach((c) => {
            if (c !== parentCat) c.classList.remove("open");
          });
          parentCat.classList.toggle("open");
        });
      });

      clonedMenu.querySelectorAll(".sub-category-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
          clonedMenu
            .querySelectorAll(".sub-category-btn")
            .forEach((b) => b.classList.remove("active"));
          btn.classList.add("active");
        });
      });

      const mobileSearchInput = popup.querySelector("#rs-search-input");
      if (mobileSearchInput) {
        mobileSearchInput.addEventListener("keyup", function () {
          performSearch(this.value);
          if (!this.value.trim()) resetToDefault();
        });
      }

      popup.classList.add("active");
    });
    if (closeBtn)
      closeBtn.addEventListener("click", () =>
        popup.classList.remove("active")
      );

    if (okBtn) {
      okBtn.addEventListener("click", () => {
        const mobileSearchInput = popup.querySelector("#rs-search-input");
        const searchQuery = mobileSearchInput
          ? mobileSearchInput.value.trim()
          : "";

        if (searchQuery) {
          performSearch(searchQuery);
          if (menuToggleLabel)
            menuToggleLabel.textContent = `Search: ${searchQuery}`;
          if (searchInputDesktop) searchInputDesktop.value = searchQuery;
        } else {
          const activeBtnInPopup = popup.querySelector(
            ".sub-category-btn.active"
          );
          if (activeBtnInPopup) {
            const { category, tab } = activeBtnInPopup.dataset;
            const selector = category
              ? `.rs-menu .sub-category-btn[data-category="${category}"][data-tab="${tab}"]`
              : `.rs-menu .sub-category-btn[data-tab="${tab}"]:not([data-category])`;
            const originalBtn = document.querySelector(selector);
            if (originalBtn) {
              originalBtn.click();
            } else {
              resetToDefault();
            }
          } else {
            resetToDefault();
          }
        }
        popup.classList.remove("active");
      });
    }
  }
  if (searchInputDesktop) searchInputDesktop.value = "";

  const videoModal = document.getElementById("videoModal");
  const videoIframe = document.getElementById("videoIframe");
  const videoPlayer = document.getElementById("videoPlayer");

  function isShopifyVideo(videoUrl, videoType) {
    return videoType === "shopify" || videoUrl.includes("shopify.com");
  }

  function openVideoModal(videoUrl, videoType = "", posterUrl = "") {
    if (!videoModal || !videoUrl) return;

    closeVideoModal();

    if (videoPlayer && isShopifyVideo(videoUrl, videoType)) {
      if (videoIframe) videoIframe.style.display = "none";
      videoPlayer.style.display = "block";
      videoPlayer.poster = posterUrl;
      videoPlayer.src = videoUrl;
      videoPlayer.load();
      videoModal.style.display = "flex";
      videoModal.setAttribute("aria-hidden", "false");
      videoPlayer.play().catch(() => {});
      return;
    }

    if (!videoIframe) return;
    const embedUrl = videoUrl.includes("youtube.com/watch?v=")
      ? videoUrl.replace("watch?v=", "embed/")
      : videoUrl;
    if (videoPlayer) videoPlayer.style.display = "none";
    videoIframe.style.display = "block";
    videoIframe.src = embedUrl;
    videoModal.style.display = "flex";
    videoModal.setAttribute("aria-hidden", "false");
  }

  function closeVideoModal() {
    if (!videoModal) return;
    if (videoIframe) videoIframe.src = "";
    if (videoPlayer) {
      videoPlayer.pause();
      videoPlayer.removeAttribute("src");
      videoPlayer.removeAttribute("poster");
      videoPlayer.load();
    }
    videoModal.style.display = "none";
    videoModal.setAttribute("aria-hidden", "true");
  }

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".video-link");
    if (trigger) {
      e.preventDefault();
      openVideoModal(
        trigger.dataset.video,
        trigger.dataset.videoType,
        trigger.dataset.videoPoster
      );
    }
    if (e.target.closest(".video-modal .close")) {
      closeVideoModal();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && videoModal?.style.display === "flex") {
      closeVideoModal();
    }
  });
});
